import { Navigate, Route, Routes } from 'react-router';
import AppLayout from '../components/layouts/AppLayout';
import AgregarAlmacen from '../pages/almacenes/AgregarAlmacen';
import EditarAlmacen from '../pages/almacenes/EditarAlmacen';
import ListaAlmacenes from '../pages/almacenes/ListaAlmacenes';
import AgregarArticulo from '../pages/articulos/AgregarArticulo';
import EditarArticulo from '../pages/articulos/EditarArticulo';
import ListaArticulos from '../pages/articulos/ListaArticulos';
import AgregarCiudad from '../pages/ciudades/AgregarCiudad';
import EditarCiudad from '../pages/ciudades/EditarCiudad';
import ListaCiudades from '../pages/ciudades/ListaCiudades';
import EditarCompra from '../pages/compras/EditarCompra';
import AgregarCorral from '../pages/corrales/AgregarCorral';
import EditarCorral from '../pages/corrales/EditarCorral';
import ListaCorrales from '../pages/corrales/ListaCorrales';
import AgregarEstado from '../pages/estados/AgregarEstado';
import EditarEstado from '../pages/estados/EditarEstado';
import ListaEstados from '../pages/estados/ListaEstados';
import GestionCorrales from '../pages/gestion-corrales/GestionCorrales';
import AgregarAgrupacionArticulos from '../pages/grupos-agrupaciones-articulos/AgregarAgrupacionArticulos';
import AgregarGrupoArticulos from '../pages/grupos-agrupaciones-articulos/AgregarGrupoArticulos';
import EditarAgrupacionArticulos from '../pages/grupos-agrupaciones-articulos/EditarAgrupacionArticulos';
import EditarGrupoArticulos from '../pages/grupos-agrupaciones-articulos/EditarGrupoArticulos';
import GruposAgrupacionesArticulos from '../pages/grupos-agrupaciones-articulos/GruposAgrupacionesArticulos';
import ListaAgrupacionesArticulos from '../pages/grupos-agrupaciones-articulos/ListaAgrupacionesArticulos';
import ListaGruposArticulos from '../pages/grupos-agrupaciones-articulos/ListaGruposArticulos';
import AgregarPerfil from '../pages/perfiles/AgregarPerfil';
import EditarPerfil from '../pages/perfiles/EditarPerfil';
import ListaPerfiles from '../pages/perfiles/ListaPerfiles';
import AgregarPersonaEntrega from '../pages/personal-entrega/AgregarPersonaEntrega';
import EditarPersonaEntrega from '../pages/personal-entrega/EditarPersonaEntrega';
import ListaPersonalEntrega from '../pages/personal-entrega/ListaPersonalEntrega';
import AgregarPersonaRecibe from '../pages/personal-recibe/AgregarPersonaRecibe';
import EditarPersonaRecibe from '../pages/personal-recibe/EditarPersonaRecibe';
import ListaPersonalRecibe from '../pages/personal-recibe/ListaPersonalRecibe';
import AgregarPersonaVende from '../pages/personal-vende/AgregarPersonaVende';
import EditarPersonaVende from '../pages/personal-vende/EditarPersonaVende';
import ListaPersonalVende from '../pages/personal-vende/ListaPersonalVende';
import EditarPreCompra from '../pages/pre-compras/EditarPreCompra';
import RegistrarPreCompra from '../pages/pre-compras/RegistrarPreCompra';
import AgregarProveedor from '../pages/proveedores/AgregarProveedor';
import EditarProveedor from '../pages/proveedores/EditarProveedor';
import ListaProveedores from '../pages/proveedores/ListaProveedores';
import AgregarTipoGanado from '../pages/tipos-ganado/AgregarTipoGanado';
import EditarTipoGanado from '../pages/tipos-ganado/EditarTipoGanado';
import ListaTiposGanado from '../pages/tipos-ganado/ListaTiposGanado';
import AgregarUbicacion from '../pages/ubicaciones/AgregarUbicacion';
import EditarUbicacion from '../pages/ubicaciones/EditarUbicacion';
import ListaUbicaciones from '../pages/ubicaciones/ListaUbicaciones';
import AgregarUnidad from '../pages/unidades/AgregarUnidad';
import EditarUnidad from '../pages/unidades/EditarUnidad';
import ListaUnidades from '../pages/unidades/ListaUnidades';
import AgregarUsuario from '../pages/usuarios/AgregarUsuario';
import EditarUsuario from '../pages/usuarios/EditarUsuario';
import ListaUsuarios from '../pages/usuarios/ListaUsuarios';
import { useAuthStore } from '../stores/auth/auth.store';

const AppRoutes = () => {
  const { user } = useAuthStore((state) => state);

  return (
    <Routes>
      <Route path="/" element={<AppLayout user={user?.nombre ?? ''} />}>
        {/* Articulos */}
        <Route path="articulos" element={<ListaArticulos />} />
        <Route path="articulos/agregar" element={<AgregarArticulo />} />
        <Route path="articulos/editar/:id" element={<EditarArticulo />} />
        {/* Ciudades */}
        <Route path="ciudades" element={<ListaCiudades />} />
        <Route path="ciudades/agregar" element={<AgregarCiudad />} />
        <Route path="ciudades/editar/:id" element={<EditarCiudad />} />
        {/* Almacenes */}
        <Route path="almacenes" element={<ListaAlmacenes />} />
        <Route path="almacenes/agregar" element={<AgregarAlmacen />} />
        <Route path="almacenes/editar/:id" element={<EditarAlmacen />} />
        {/* Compras */}
        <Route path="compras" element={<EditarCompra />} />
        <Route path="compras/editar/:id" element={<EditarCompra />} />
        {/* Corrales */}
        <Route path="corrales" element={<ListaCorrales />} />
        <Route path="corrales/agregar" element={<AgregarCorral />} />
        <Route path="corrales/editar/:id" element={<EditarCorral />} />
        {/* Estados */}
        <Route path="estados" element={<ListaEstados />} />
        <Route path="estados/agregar" element={<AgregarEstado />} />
        <Route path="estados/editar/:id" element={<EditarEstado />} />
        {/* Grupos y Agrupaciones */}
        <Route
          path="grupos-agrupaciones-articulos/grupos/agregar"
          element={<AgregarGrupoArticulos />}
        />
        <Route
          path="grupos-agrupaciones-articulos/grupos/editar/:id"
          element={<EditarGrupoArticulos />}
        />
        <Route
          path="grupos-agrupaciones-articulos/agrupaciones/agregar"
          element={<AgregarAgrupacionArticulos />}
        />
        <Route
          path="grupos-agrupaciones-articulos/agrupaciones/editar/:id"
          element={<EditarAgrupacionArticulos />}
        />
        <Route path="grupos-agrupaciones-articulos/" element={<GruposAgrupacionesArticulos />}>
          <Route path="grupos" element={<ListaGruposArticulos />} />
          <Route path="agrupaciones" element={<ListaAgrupacionesArticulos />} />
        </Route>
        {/* Proveedores */}
        <Route path="proveedores" element={<ListaProveedores />} />
        <Route path="proveedores/agregar" element={<AgregarProveedor />} />
        <Route path="proveedores/editar/:id" element={<EditarProveedor />} />
        {/* Perfiles */}
        <Route path="perfiles" element={<ListaPerfiles />} />
        <Route path="perfiles/agregar" element={<AgregarPerfil />} />
        <Route path="perfiles/editar/:id" element={<EditarPerfil />} />
        {/* PersonalEntrega */}
        <Route path="personal-entrega" element={<ListaPersonalEntrega />} />
        <Route path="personal-entrega/agregar" element={<AgregarPersonaEntrega />} />
        <Route path="personal-entrega/editar/:id" element={<EditarPersonaEntrega />} />
        {/* PersonalRecibe */}
        <Route path="personal-recibe" element={<ListaPersonalRecibe />} />
        <Route path="personal-recibe/agregar" element={<AgregarPersonaRecibe />} />
        <Route path="personal-recibe/editar/:id" element={<EditarPersonaRecibe />} />
        {/* PersonalVende */}
        <Route path="personal-vende" element={<ListaPersonalVende />} />
        <Route path="personal-vende/agregar" element={<AgregarPersonaVende />} />
        <Route path="personal-vende/editar/:id" element={<EditarPersonaVende />} />
        {/* Pre-compras */}
        <Route path="pre-compras/registrar" element={<RegistrarPreCompra />} />
        <Route path="pre-compras/editar/:id" element={<EditarPreCompra />} />
        {/* TiposGanado */}
        <Route path="tipos-ganado" element={<ListaTiposGanado />} />
        <Route path="tipos-ganado/agregar" element={<AgregarTipoGanado />} />
        <Route path="tipos-ganado/editar/:id" element={<EditarTipoGanado />} />
        {/* Ubicaciones */}
        <Route path="ubicaciones" element={<ListaUbicaciones />} />
        <Route path="ubicaciones/agregar" element={<AgregarUbicacion />} />
        <Route path="ubicaciones/editar/:id" element={<EditarUbicacion />} />
        {/* Unidades */}
        <Route path="unidades" element={<ListaUnidades />} />
        <Route path="unidades/agregar" element={<AgregarUnidad />} />
        <Route path="unidades/editar/:id" element={<EditarUnidad />} />
        {/* Usuarios */}
        <Route path="usuarios" element={<ListaUsuarios />} />
        <Route path="usuarios/agregar" element={<AgregarUsuario />} />
        <Route path="usuarios/editar/:id" element={<EditarUsuario />} />
        {/* Gestion de Corrales */}
        <Route path="gestion-corrales" element={<GestionCorrales />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
